import isNil from 'lodash/isNil';
import MAIN_API_CLIENT, {
  API_CLIENT_NAMES,
  getCancelToken,
  SECONDARY_API_CLIENT
} from 'services/API';
import strings from 'strings';

import { PRIORITY_CLASS_NAMES } from './AdvancedSearch.constants';

const getApiClient = apiClient => {
  const clientMap = {
    [API_CLIENT_NAMES.Primary]: MAIN_API_CLIENT,
    [API_CLIENT_NAMES.Secondary]: SECONDARY_API_CLIENT
  };
  return clientMap[apiClient] || MAIN_API_CLIENT;
};

export const mapPriorityToClassName = priority => {
  return PRIORITY_CLASS_NAMES[priority] || PRIORITY_CLASS_NAMES.can_have;
};

export const findPriorityById = (priorities, priorityId) => {
  if (!priorities || !priorityId) return null;
  return priorities.find(p => p.id === priorityId) || null;
};

export const extractShortLabel = (priorityObj, fallback = 'Can') => {
  return priorityObj?.shortLabel || fallback;
};

export const checkIfItemSelected = ({ selectedItems, newItem, getOptionId }) => {
  return selectedItems.some(item => getOptionId(item.item) === getOptionId(newItem));
};

export const createSelectedItem = ({ item, priority, preference = null }) => ({
  id: Date.now(),
  item,
  priority,
  ...(preference && { preference })
});

export const removeItemFromSelection = (selectedItems, itemToRemove) => {
  return selectedItems.filter(item => item.id !== itemToRemove.id);
};

export const updateItemPriority = ({ selectedItems, itemId, newPriority }) => {
  return selectedItems.map(item =>
    item.id === itemId ? { ...item, priority: newPriority } : item
  );
};

export const updateItemPreference = ({ selectedItems, itemId, newPreference }) => {
  return selectedItems.map(item =>
    item.id === itemId ? { ...item, preference: newPreference } : item
  );
};

export const findItemById = (selectedItems, itemId) => {
  return selectedItems.find(item => item.id === itemId);
};

export const extractOptionLabel = option => {
  if (!option) return '';
  return option.name || option.title || option.label || '';
};

export const extractOptionId = option => {
  return option?.id;
};

export const defaultFetchOptions = async (inputValue, params = {}, onCancelToken) => {
  const { endpoint, apiClient = API_CLIENT_NAMES.Primary, queryKey, ...restParams } = params;

  if (!endpoint) {
    throw new Error('endpoint is required in params');
  }

  const cancelTokenSource = getCancelToken();

  if (onCancelToken) {
    onCancelToken(cancelTokenSource);
  }

  const client = getApiClient(apiClient);

  try {
    const queryParams = {
      ...restParams
    };

    // Only include term if inputValue is provided
    if (inputValue && !isNil(inputValue)) {
      queryParams[queryKey || 'term'] = inputValue;
    }

    const response = await client.get(endpoint, {
      params: queryParams,
      cancelToken: cancelTokenSource.token
    });

    const { data } = response;

    return {
      data: data?.data ?? data ?? [],
      field: data?.query?.field ?? null
    };
  } catch (error) {
    if (error?.message === strings.shared.requests.cancelTokenMessage) {
      return { data: [], field: null };
    }
    throw error;
  }
};
